"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageEnum = void 0;
var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["ENGLISH"] = "EN";
    LanguageEnum["ROMANIAN"] = "RO";
    LanguageEnum["HUNGARIAN"] = "HU";
})(LanguageEnum || (exports.LanguageEnum = LanguageEnum = {}));
//# sourceMappingURL=LanguageEnum.js.map